
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 24 24\" id=\"icon-directions\" > <path d=\"M 24 12 C 24 18.627 18.627 24 12 24 C 5.373 24 0 18.627 0 12 C 0 5.373 5.373 0 12 0 C 18.627 0 24 5.373 24 12 Z M 14.1 9.3 L 12.822 10.578 L 16.053 13.8 L 7.8 13.8 L 7.8 4.8 L 6 4.8 L 6 15.6 L 16.053 15.6 L 12.822 18.822 L 14.1 20.1 L 19.5 14.7 Z\"/> </symbol>";
module.exports = sprite.add(image, "icon-directions");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/directions.svg
 ** module id = 167
 ** module chunks = 24
 **/